import { useRouter } from "next/router";

import StackLayout from "@domains/common/views/layouts/StackLayout/StackLayout";
import { NAVIGATION_ROUTE } from "@domains/common/constants/navigationRoute";
import AdminComponent from "@domains/auth/views/admin/AdminComponent";

const Admin = () => {
  const { back, push } = useRouter();

  const handleBack = () => {
    if (window.history.length > 1) {
      back();
    } else {
      push(NAVIGATION_ROUTE.EVENT_LIST.HREF);
    }
  };

  return (
    <StackLayout
      navbar={{
        iconType: "CHEVRON_LEFT",
        onClickIcon: handleBack,
        title: "Admin",
      }}
    >
      <AdminComponent />
    </StackLayout>
  );
};

export default Admin;
